import { Loader2 } from 'lucide-react';
import { cn } from '../lib/utils';

interface PageLoaderProps {
  message?: string;
  className?: string;
  fullscreen?: boolean;
}

export const PageLoader = ({
  message = 'Loading...',
  className,
  fullscreen = false,
}: PageLoaderProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center px-6 py-10',
        fullscreen ? 'min-h-screen bg-background' : 'min-h-[60vh]',
        className
      )}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/8">
          <Loader2
            className="h-7 w-7 animate-spin text-primary"
            style={{ animationDuration: '0.55s' }}
          />
        </div>
        <p className="text-sm font-semibold text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};
